// TODO Server should return the category name styles data. Hardcoded here for now.
/**
 * Gets the text label to use as the style category name in GUI.
 * @param {string} categoryName Category name as part of `styleName`.
 * @returns {string}
 */
const getStyleCategoryLabel = categoryName => {
  // Create spaces and convert to upper case.
  return categoryName.replace('_', ' ').toUpperCase();
};

export default getStyleCategoryLabel;
